import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export type PracticeAgentWidgetOpenResult = 'no-relevant-card' | 'card-api-failed' | 'already-open-elsewhere' | 'temporarily-unavailable';

@Injectable({ providedIn: 'root' })
export class PracticeAgentWidgetControlService {
  private readonly openRequestSubject = new Subject<void>();
  private readonly visibleSubject = new BehaviorSubject(false);
  private readonly homePageActiveSubject = new BehaviorSubject(false);
  private readonly openResultSubject = new BehaviorSubject<PracticeAgentWidgetOpenResult | null>(null);

  readonly openRequested$ = this.openRequestSubject.asObservable();
  readonly visible$ = this.visibleSubject.asObservable();
  readonly homePageActive$ = this.homePageActiveSubject.asObservable();
  readonly openResult$ = this.openResultSubject.asObservable();

  openWidget(): void {
    this.openResultSubject.next(null);
    this.openRequestSubject.next();
  }

  setVisible(visible: boolean): void {
    this.visibleSubject.next(visible);
    if (visible) {
      this.openResultSubject.next(null);
    }
  }

  setHomePageActive(active: boolean): void {
    this.homePageActiveSubject.next(active);
  }

  setOpenResult(result: PracticeAgentWidgetOpenResult): void {
    this.openResultSubject.next(result);
  }
}
